import { AllAssetsSubCatagoryResponseModel, AssetsSubCatagoryResponse, AssetsSubCatagoryResponseModel } from '@gtpl/shared-models/asset-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { AssetsSubCatagoryService } from './assets-sub-catagory.service';
import { AssetsSubRequest } from './dto/assets-sub-catagory-active-deactive';
import { AssetsSubCatagoryDTO } from './dto/assets-sub-catagory-dto';
import { assetsSSubCatagoryByIdReq } from './dto/assets-sub-catagory-request';

@ApiTags('assets-sub-catagory')
@Controller('assets-sub-catagory')
export class AssetsSubCatagoryController {
    constructor(private assetsSubCatagoryService: AssetsSubCatagoryService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('/createAssetsSubCatagory')
    async createAssetsSubCatagory(@Body() assetsCatagoryDTO: AssetsSubCatagoryDTO): Promise<AssetsSubCatagoryResponseModel> {
        try {
            return await this.assetsSubCatagoryService.createAssetsSubCatagory(assetsCatagoryDTO, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsSubCatagoryResponseModel, error);
        }
    }

    @Post('/updateAssetsClassification')
    async updateAssetsClassification(@Body() assetsCatagoryDTO: AssetsSubCatagoryDTO): Promise<AssetsSubCatagoryResponseModel> {
        try {
            return await this.assetsSubCatagoryService.createAssetsSubCatagory(assetsCatagoryDTO, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsSubCatagoryResponseModel, error);
        }
    }

    @Post('getRecordByAssetsClassificationId')
    async getRecordByAssetsClassificationId(@Body() id: assetsSSubCatagoryByIdReq): Promise<AssetsSubCatagoryResponseModel> {
        try {
            return await this.assetsSubCatagoryService.getRecordByAssetsClassificationId(id.assetsSubCatagoryId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsSubCatagoryResponseModel, error);
        }
    }

    @Post('getAllAssetsSubCatagory')
    async getAllAssetsSubCatagory(): Promise<AllAssetsSubCatagoryResponseModel> {
        try {
            return await this.assetsSubCatagoryService.getAllAssetsSubCatagory();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllAssetsSubCatagoryResponseModel, error);
        }
    }

    @Post('activateorDeactivateAssets')
    async activateorDeactivateAssets(@Body() assetsSubRequest: AssetsSubRequest): Promise<AssetsSubCatagoryResponse> {
        try {
            return await this.assetsSubCatagoryService.activateorDeactivateAssets(assetsSubRequest);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssetsSubCatagoryResponse, error);
        }
    }



}
